export default "__VITE_ASSET__C_Bg0OK6__"